import { get, isEmpty, map, stubFalse } from 'lodash'

const buildTreeHierarchy = (
  treeData,
  metadataType,
  parentKey = '',
  parentPath = '',
  keyPath = [],
  level = 1,
  shouldDisableNode = stubFalse,
) =>
  map(treeData, (item, index) => {
    const nodeKey = isEmpty(parentKey) ? `${index}` : `${parentKey}-${index}`

    const nodePath = isEmpty(parentPath)
      ? `[${index}]`
      : `${parentPath}.children[${index}]`

    const nodeKeyPath = isEmpty(keyPath)
      ? [`${index}`]
      : [...keyPath, `${parentKey}-${index}`]

    return {
      ...item,
      key: nodeKey,
      path: nodePath,
      keyPath: nodeKeyPath,
      parentPath,
      level,
      disabled: shouldDisableNode(item),
      allowedOperations: get(metadataType, 'allowedOperations'),
      children: !isEmpty(item?.children)
        ? buildTreeHierarchy(
            item.children,
            metadataType,
            nodeKey,
            nodePath,
            nodeKeyPath,
            level + 1,
            shouldDisableNode,
          )
        : undefined,
    }
  })

export default buildTreeHierarchy
